import { hasQuestions, getAnswers, isQuestionComplete } from "../../../selectors/questions";
import {getCheckoutClient} from "../../../config/CheckoutClient";
import { addAlert } from "../../../actions/ui";

export function setAnswer(questionId, id, resourceType, answer) {
    return {type: "SET_ANSWER", questionId, id, resourceType, answer};
}

export function setQuestions(questionSet) {
    return {type: "SET_QUESTIONS", questionSet};
}

export function submitQuestions() {
    return (dispatch, getState) => {
        let state = getState();
        if(!hasQuestions(state)) {
            return Promise.resolve();
        }

        if(isQuestionComplete(state)) {
            dispatch(addAlert("checkout__please_answer_all_required_questions"));
            return Promise.reject("Please answer all required questions");
        }

        let payload = {
            answers: getAnswers(state)
        }

        return getCheckoutClient(state.ui.apiUrl).reservationCreateRequest(state.reservation.token, 'answers', payload, state.reservation.secret).then((response) => {
            // don't need to really do anything in here
            // maybe check unanswered required flag in here?
        }).catch((e) => {
            return Promise.reject(e);
        });
    }
}

export function fetchQuestions(token, secret) {
    return (dispatch, getState) => {
        let state = getState();
        return getCheckoutClient(state.ui.apiUrl).reservationGetRequest(token, 'questions', secret).then((result) => {
            dispatch(setQuestions(result.body.data.attributes.question_set));
            return Promise.resolve();
        });
    }
}
